export default __webpack_public_path__ + "static/banner-documentation-2-abaf585d9354cd8081b96db5a7a91b53.jpg";